import React, { Fragment, useContext } from 'react';
import { connect } from 'react-redux';

import FieldEdit from 'field/edit/FieldEdit';

import Types, { isLiteral } from 'constants/types';
import LocaleContext from 'constants/localization';
import CheckboxWithToolTip from 'components/common/CheckboxWithTooltip';
import { toggleAllow, toggleAdd, setAllowed } from 'actions/fieldActions';

import LocalizedStrings from 'react-localization';

const MassEditField = ({ field, added, allowed, 
  toggleAdd, toggleAllow }) => {
  const { predicate, type } = field;
  const maxOccurs = field.props.maxOccurs;
  const LS = useContext(LocaleContext);

  const allowInputId = `${predicate}_allow`;
  const addInputId = `${predicate}_add`;
  
  const AllowCheckbox = () =>  (
    <CheckboxWithToolTip 
      onChange={() => toggleAllow(predicate)}
      checked={allowed}
      tooltip={LS.actions.send}
      id={allowInputId}
    />
  );
  
  const AddCheckbox = () => {
    // Literals may use 'add' to append text when maxOccurs 1
    if (maxOccurs < 2 && !isLiteral(type) || type === Types.XSD.BOOLEAN) {
      return null;
    }
   
    return (
      <CheckboxWithToolTip
        onChange={() => toggleAdd(predicate)}
        checked={added}
        tooltip={LS.actions.add}
        id={addInputId}
      />
    );
  };

  const HelpLabel = () => {
    helpStrings.setLanguage(LS.getLanguage());

    if (!allowed) {
      if (added) {
        return <label>{helpStrings.addedNotAllowed}</label>;
      }
      return null;
    } else if (!added) {
      return <label>{helpStrings.overWritten}</label>;
    }
    else if (maxOccurs === 1) {
      if (isLiteral(type)) {
        return <label>{helpStrings.addedText}</label>;
      }
    }
    return <label>{helpStrings.addedNew}</label>;
  };

  return (
    <Fragment>
      <div style={{ marginBottom: '0.5rem' }}>
        <AllowCheckbox />
        <AddCheckbox />
        <HelpLabel />
      </div>
      <FieldEdit field={field} />
    </Fragment>
  );
};

const helpStrings = new LocalizedStrings({
  fi: {
    addedNotAllowed: 'Valitse Lähetä lähettääksesi arvon.',
    overWritten: 'Arvo ylikirjoitetaan.',
    addedText: 'Arvo lisätään tekstikentän perään.',
    addedNew: 'Arvo lisätään arvojoukkoon.'
  },
  en: {
    addedNotAllowed: 'Toggle Send to update the value.',
    overWritten: 'The value will be overwritten.',
    addedText: 'The text will be added after the previous text.',
    addedNew: 'The value will be added to value group.'
  }
});

const mapStateToProps = (state, props) => {
  const predicate = props.field.predicate;
  return {
    allowed: state.massedit.allowed[predicate],
    added: state.massedit.added[predicate] 
  };
};

export default connect(mapStateToProps, 
  { toggleAdd, toggleAllow, setAllowed })(MassEditField);